import type DocumentSettingsFormData from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/FormData/DocumentSettingsFormData';
import type WorkflowFormData from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/FormData/WorkflowFormData';

/**
 * One line summing up what a document receives and how it is written: its inputs that exist at its
 * position within the group, then its prompts, re-evaluation and splitting.
 */
const describeDocument = (
	document: DocumentSettingsFormData,
	draft: WorkflowFormData,
	stageIndex: number,
): string => {
	const inputs: string[] = [];

	if (document.preparationElements) {
		inputs.push('éléments');
	}

	if (stageIndex > 0 && document.previousStepDocumentsMode !== 'none') {
		inputs.push(
			document.previousStepDocumentsMode === 'all' ? 'étapes précédentes' : 'documents choisis',
		);
	}

	if (draft.automaticSources.length > 0) {
		inputs.push(
			document.automaticSourcesMode === 'all' ? 'documents repris' : 'documents repris choisis',
		);
	}

	const parts = [
		`Reçoit : ${inputs.length > 0 ? inputs.join(', ') : 'rien'}`,
		`consignes ${document.hasPersonalizedPrompts ? 'personnalisées' : 'par défaut'}`,
	];

	if (document.reevaluationEnabled) {
		parts.push('avec réévaluation');
	}

	if (document.splitCalls) {
		parts.push('section par section');
	}

	return parts.join(' · ');
};

export default describeDocument;
